module.exports = __webpack_public_path__ + "img/acreditaciones.392ad984.jpg";